export const tableStyles = {
  table: {
    style: {
      //   border: '1px solid #e2e8f0', // light gray outline
      borderRadius: '0.4rem',
      overflow: 'hidden', // ensures radius applies to child elements
      backgroundColor: '#f8fafc', // light gray background for body
    },
  },

  headRow: {
    style: {
      backgroundColor: '#1B8F9B',
      minHeight: '52px',
      borderBottomWidth: '1px',
      borderBottomColor: '#166B75',
      borderBottomStyle: 'solid',
    },
  },

  headCells: {
    style: {
      paddingLeft: '12px',
      paddingRight: '12px',
      paddingTop: '6px',
      paddingBottom: '6px',
      '&:first-of-type': {
        paddingLeft: '20px',
      },
      '&:last-of-type': {
        paddingRight: '20px',
      },
      backgroundColor: '#1B8F9B', // Primary color
      color: '#ffffff',
      fontSize: '14px',
      letterSpacing: '0.5px',
    },
  },
  rows: {
    style: {
      backgroundColor: '#f8fafc', // match body bg
      borderBottom: '1px solid #e2e8f0',
      '&:hover': {
        backgroundColor: '#E8F5F6', // subtle brand tint on hover
      },
    },
  },
  cells: {
    style: {
      paddingLeft: '12px',
      paddingRight: '12px',
      paddingTop: '3px',
      paddingBottom: '3px',
      // fontSize: '14px',
      color: '#374151',
      '&:first-of-type': {
        paddingLeft: '20px',
      },
      '&:last-of-type': {
        paddingRight: '20px',
      },
    },
  },
  expanderRow: {
    style: {
      backgroundColor: '#f8fafc',
      borderBottom: 'none',
    },
  },
  expanderCell: {
    style: {
      padding: '0',
    },
  },
  expanderButton: {
    style: {
      color: '#6b7280',
      backgroundColor: 'transparent',
      borderRadius: '4px',
      transition: 'all 0.2s ease',
      '&:hover': {
        color: '#1B8F9B',
        backgroundColor: '#f3f4f6',
      },
      '&:not(:disabled)': {
        cursor: 'pointer',
      },
    },
  },
  pagination: {
    style: {
      backgroundColor: '#f8fafc', // same light gray as body
      borderTop: '1px solid #e2e8f0',
      padding: '16px 20px',
      fontSize: '14px',
      color: '#475569',
      borderBottomLeftRadius: '0.4rem',
      borderBottomRightRadius: '0.4rem',
    },
    pageButtonsStyle: {
      borderRadius: '6px',
      height: '36px',
      width: '36px',
      padding: '0',
      margin: '0 2px',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      backgroundColor: 'transparent',
      border: '1px solid #e2e8f0',
      color: '#475569',
      '&:hover': {
        backgroundColor: '#E8F5F6',
        borderColor: '#1B8F9B',
        color: '#1B8F9B',
      },
      '&:focus': {
        outline: '2px solid #1B8F9B',
        outlineOffset: '2px',
      },
      '&[aria-current="page"]': {
        backgroundColor: '#1B8F9B',
        borderColor: '#1B8F9B',
        color: '#ffffff',
      },
    },
  },
};

export const tableStylesNew = {
  table: {
    style: {
      borderTopLeftRadius: '0.6rem',
      borderTopRightRadius: '0.6rem',
      border: '1px solid #e2e8f0',
      borderBottom: 'none',
      overflow: 'hidden', // ensures radius applies to child elements
      backgroundColor: '#f8fafc', // light gray background for body
    },
  },

  headRow: {
    style: {
      backgroundColor: '#e8f7f8',
      minHeight: '46px',
      borderBottomWidth: '1px',
      borderBottomColor: '#e2e8f0',
      borderBottomStyle: 'solid',
    },
  },

  headCells: {
    style: {
      paddingLeft: '12px',
      paddingRight: '12px',
      paddingTop: '6px',
      paddingBottom: '6px',
      '&:first-of-type': {
        paddingLeft: '20px',
      },
      '&:last-of-type': {
        paddingRight: '20px',
      },
      backgroundColor: '#e8f7f8', // Primary color
      color: '#1b8f9b',
      fontSize: '12px',
      letterSpacing: '0.5px',
    },
  },
  rows: {
    style: {
      backgroundColor: '#ffffff', // match body bg
      borderBottom: '1px solid #e2e8f0',
      '&:hover': {
        backgroundColor: '#E8F5F6', // subtle brand tint on hover
      },
    },
  },
  cells: {
    style: {
      paddingLeft: '12px',
      paddingRight: '12px',
      paddingTop: '3px',
      paddingBottom: '3px',
      // fontSize: '14px',
      color: '#374151',
      '&:first-of-type': {
        paddingLeft: '20px',
      },
      '&:last-of-type': {
        paddingRight: '20px',
      },
    },
  },
  expanderRow: {
    style: {
      backgroundColor: '#f8fafc',
      borderBottom: 'none',
    },
  },
  expanderCell: {
    style: {
      padding: '0',
    },
  },
  expanderButton: {
    style: {
      color: '#6b7280',
      backgroundColor: 'transparent',
      borderRadius: '4px',
      transition: 'all 0.2s ease',
      '&:hover': {
        color: '#1B8F9B',
        backgroundColor: '#f3f4f6',
      },
      '&:not(:disabled)': {
        cursor: 'pointer',
      },
    },
  },
  pagination: {
    style: {
      backgroundColor: '#f8fafc', // same light gray as body
      borderTop: '1px solid #e2e8f0',
      padding: '16px 20px',
      fontSize: '14px',
      color: '#475569',
      borderBottomLeftRadius: '0.4rem',
      borderBottomRightRadius: '0.4rem',
    },
    pageButtonsStyle: {
      borderRadius: '6px',
      height: '36px',
      width: '36px',
      padding: '0',
      margin: '0 2px',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      backgroundColor: 'transparent',
      border: '1px solid #e2e8f0',
      color: '#475569',
      '&:hover': {
        backgroundColor: '#E8F5F6',
        borderColor: '#1B8F9B',
        color: '#1B8F9B',
      },
      '&:focus': {
        outline: '2px solid #1B8F9B',
        outlineOffset: '2px',
      },
      '&[aria-current="page"]': {
        backgroundColor: '#1B8F9B',
        borderColor: '#1B8F9B',
        color: '#ffffff',
      },
    },
  },
};

// PREMIUM RECEIPT STYLE TABLE
export const invoiceStyleTable = {
  table: {
    style: {
      border: '1.5px solid #1f2937',
      borderBottom: 'none',
      backgroundColor: '#f5f5f5',
      overflow: 'hidden',
      borderRadius: '0',
    },
  },

  headRow: {
    style: {
      minHeight: '56px',
      backgroundColor: '#ececec',
      borderBottom: '1.5px solid #1f2937',
    },
  },

  headCells: {
    style: {
      backgroundColor: '#ececec',
      color: '#111827',
      fontSize: '15px',
      fontWeight: '700',
      textTransform: 'uppercase',
      borderRight: '1px solid #1f2937',
      paddingTop: '12px',
      paddingBottom: '12px',
      paddingLeft: '14px',
      paddingRight: '14px',
      whiteSpace: 'normal',
      lineHeight: '20px',

      '&:last-of-type': {
        borderRight: 'none',
      },
    },
  },

  rows: {
    style: {
      minHeight: '72px',
      backgroundColor: '#f8f8f8',
      borderBottom: '1px solid #1f2937',

      '&:hover': {
        backgroundColor: '#efefef',
      },

      '&:last-of-type': {
        borderBottom: 'none',
      },
    },
  },

  cells: {
    style: {
      color: '#111827',
      fontSize: '15px',
      fontWeight: '500',
      borderRight: '1px solid #1f2937',
      paddingTop: '14px',
      paddingBottom: '14px',
      paddingLeft: '14px',
      paddingRight: '14px',
      alignItems: 'flex-start',

      '&:last-of-type': {
        borderRight: 'none',
      },
    },
  },

  pagination: {
    style: {
      border: '1.5px solid #1f2937',
      borderTop: 'none',
      backgroundColor: '#f5f5f5',
      minHeight: '56px',
    },

    pageButtonsStyle: {
      borderRadius: '0',
      border: '1px solid #1f2937',
      height: '34px',
      width: '34px',
      padding: '0',
      margin: '0 2px',
      cursor: 'pointer',
      backgroundColor: '#ffffff',
      color: '#111827',

      '&:hover': {
        backgroundColor: '#ececec',
      },

      '&:disabled': {
        opacity: 0.4,
      },
    },
  },
};
